module.exports = __webpack_public_path__ + "img/banner-home@1x.00c2983c.jpg";